module.exports = "/images/vessel-15.jpg";